import { reactive as e } from "vue";
const t = e({
  locale: "en",
  uiDatePicker: {
    beginDate: "2022-01-01",
    modelValueFormat: "YYYY-MM-DD",
    inputFormat: "DD.MM.YYYY",
    translations: {
      invalidDate: "The date is incorrect",
      todayPlaceholder: "Today",
      yesterdayPlaceholder: "Yesterday",
      emptyPlaceholder: "Choose date",
      applyButton: "Apply",
      clearButton: "Clear",
      inputLabelStart: "Start",
      inputLabelEnd: "End",
      presetToday: "Today",
      presetWeek: "Week",
      presetMonth: "Month",
      presetQuarter: "Quarter",
      presetYear: "Year",
      presetAllTime: "All time"
    }
  },
  uiLanguages: {
    translations: {
      searchInputPlaceholder: "Search",
      modalSearchNotFound: "Nothing found",
      changeLanguage: "Change language"
    }
  },
  uiSelect: {
    translations: {
      searchInputPlaceholder: "Search",
      notFound: "Nothing found",
      multipleSelectedText: "Selected:"
    }
  },
  uiTable: {
    translations: {
      noData: "No data"
    }
  },
  uiPagination: {
    translations: {
      show: "Show",
      from: "from"
    }
  },
  uiConfirm: {
    translations: {
      confirmBtn: "Confirm",
      cancelBtn: "Cancel"
    }
  },
  uiDragAndDrop: {
    translations: {
      file: "File",
      dragOr: "Drag the file or",
      selectHere: "select here",
      cancel: "Cancel"
    }
  },
  uiNotification: {
    translations: {
      error: "Error",
      success: "Success"
    }
  }
});
export {
  t as config
};
